import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useState } from 'react'
import ChevronDown from '@/assets/svgs/chevron-down.svg?react'

const AccordionCard = ({
  title,
  children,
  defaultOpen = true,
  className = '',
  contentClassName = '',
}) => {
  const [isCollapsed, setIsCollapsed] = useState(!defaultOpen)

  return (
    <div
      className={clsx(
        'w-full mt-2 sm:py-6 sm:px-7 py-4 px-4 border border-grey-90 rounded-2xl bg-white',
        className
      )}
    >
      <div
        className={clsx(
          'flex items-center gap-2 cursor-pointer sm:-mx-7 sm:px-7 -mx-4 px-4 border-b transition-[padding-bottom,border-color] duration-300 ease-in-out',
          isCollapsed ? 'pb-0 border-transparent' : 'pb-6 border-grey-90'
        )}
        onClick={() => setIsCollapsed(v => !v)}
        role="button"
        aria-expanded={!isCollapsed}
      >
        <span
          className={clsx(
            'flex items-center justify-center w-4 h-4 shrink-0 text-grey-30 transition-transform duration-300 [&_svg]:w-3 [&_svg]:h-3',
            isCollapsed ? '-rotate-90' : ''
          )}
        >
          <ChevronDown />
        </span>
        <div className="flex-1 text-sm leading-5 font-semibold text-grey-30">{title}</div>
      </div>
      <div
        className={clsx(
          'flex flex-col overflow-hidden transition-[max-height,padding-top] duration-300 ease-in-out',
          isCollapsed ? 'max-h-0' : clsx('max-h-250', contentClassName)
        )}
      >
        {children}
      </div>
    </div>
  )
}

AccordionCard.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  defaultOpen: PropTypes.bool,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
}

export default AccordionCard
